<div fxLayout="row">
  <div *ngFor="let action of actions" class="u-marginLeft-8">
    <button
      *ngIf="!action.raised"
      mat-button
      [disabled]="action.canBeDisabled ? action.disable : false"
      (click)="action.callback ? actionClick(action) : {}"
      [color]="action.color"
    >
      <span i18n="@@settingsView.actionBar.buttonLabel">{action.text, select,
        other {{{ action.text }}}
      }</span>
    </button>
    <button
      *ngIf="action.raised"
      mat-raised-button
      [disabled]="action.canBeDisabled ? action.disable : false"
      (click)="action.callback ? actionClick(action) : {}"
      [color]="action.color"
    >
      <span i18n="@@settingsView.actionBar.buttonLabel">{action.text, select,
        other {{{ action.text }}}
      }</span>
    </button>
  </div>
</div>
